import traceData from "./edgeMentorTrace.json";

const traceMap = Object.fromEntries(
  (traceData.fields || []).map((field) => [field.field_name, field]),
);

export function getEdgeMentorTrace(fieldName) {
  return traceMap[fieldName] ?? null;
}
